import Vue from 'vue';
import Router from 'vue-router';
import About from './views/About.vue';
import Viewer from './views/Viewer.vue';
import NotFound from './views/NotFound.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      component: NotFound,
    },
    {
      name: 'index',
      path: '/index.html',
      component: () => import('./views/Home.vue'),
    },
    {
      name: 'ログイン',
      path: '/',
      component: () => import('./views/Home.vue'),
    },
    {
      name: 'パスワード更新',
      path: '/password',
      component: () => import('./views/NewPassword.vue'),
    },
    {
      name: 'パスワードリセット',
      path: '/resetPassword',
      component: () => import('./views/ResetPassword.vue'),
    },
    {
      name: 'パスワード再登録',
      path: '/submitPassword',
      component: () => import('./views/SubmitPassword.vue'),
    },
    {
      path: '/about',
      component: () => import('./views/About.vue'),
    },
    {
      path: '/organization',
      component: () => import('./views/Viewer.vue'),
      children: [
        {
          name: '団体一覧',
          path: '',
          component: () => import('./views/Organization.vue'),
        },
        {
          name: '団体作成',
          path: 'new',
          component: () => import('./views/NewOrganization.vue'),
        },
        {
          path: ':id',
          component: () => import('./views/OrganizationDetail.vue'),
          props: true,
        },
      ],
    },
    {
      name: 'ユーザー設定',
      path: '/user',
      component: () => import('./views/User.vue'),
    },
    {
      name: 'メンバー追加',
      path: '/newmember',
      component: () => import('./views/NewMember.vue'),
    },
    {
      name: 'メールアドレス確認',
      path: '/verifyemail',
      component: () => import('./views/VerifyEmail.vue'),
    },
    {
      name: 'QRコード',
      path: '/qrcode_table',
      component: () => import('./views/QRCodeTable.vue'),
    },
    {
      path: '/group',
      component: () => import('./views/Viewer.vue'),
      children: [
        {
          name: 'グループ一覧',
          path: '',
          component: () => import('./views/OrganizationDetail.vue'),
        },
        {
          name: 'グループ作成',
          path: 'new',
          component: () => import('./views/NewGroup.vue'),
        },
        {
          path: ':groupid',
          component: Viewer,
          children: [
            {
              path: '',
              component: () => import('./views/GroupDetail.vue'),
              props: true,
            },
            {
              name: 'メッセージ作成',
              path: 'send',
              component: () => import('./views/Send.vue'),
              props: true,
            },
            {
              path: 'message/:msgid',
              name: 'メッセージ',
              component: () => import('./views/MessageDetail.vue'),
              props: true,
            },
          ],
        },
      ],
    },
  ],
});
